import EventEmitter from 'eventemitter3'

export const emitter = new EventEmitter()
